import React from 'react';
import './App.scss';
import NavBar from './components/navbar/NavBar';
import Home from './components/home/Home';
import AboutUs from './components/about-us/AboutUs';
import { Route, Switch } from 'react-router-dom';
import Footer from './components/footer/Footer';
import Contact from './components/contact/Contact';
import Products from './components/products/Products';
import Cart from './components/cart/Cart';
import WhatsNew from './components/whats-new/WhatsNew';
import { getCart } from './components/util/localStorage';
import InDevelopment from './components/util/InDevelopment';
import ProductDetails from './components/product-details/ProductDetails';
import Admin from './components/admin/Admin'
import PageNotFoundError from './components/404/PageNotFoundError';

const TITLE_ASC = 'title asc';

class App extends React.Component {

   constructor(props) {
      super(props);

      this.state = {
         cartStorage: getCart() || [],
         currency: 'USD',
         lastProductPage: 1,
         search: '',
         searchType: 'by title',
         filter: '',
         sort: TITLE_ASC,
         hideNavSearch: false,
         publisher: 'ip'
      }

      this.updateCartStorage = this.updateCartStorage.bind(this);
      this.setCurrency = this.setCurrency.bind(this);
      this.updateLastProductPage = this.updateLastProductPage.bind(this);
      this.setSearch = this.setSearch.bind(this);
      this.setFilter = this.setFilter.bind(this);
      this.setSort = this.setSort.bind(this);
      this.setSearchType = this.setSearchType.bind(this);
      this.setHideNavSearch = this.setHideNavSearch.bind(this);
      this.setPublisher = this.setPublisher.bind(this);
   }

   componentWillUnmount() {

   }

   setCurrency(currency) {
      if (currency.value !== this.state.currency && (currency.value === 'CAD' || currency.value === 'USD')) {
         this.setState({
            currency: currency.value
         });
      }
   }

   updateCartStorage() {
      this.setState({ cartStorage: getCart() || []});
   }

   updateLastProductPage(lastProductPage) {
      if (this.state.lastProductPage !== lastProductPage) {
         this.setState({
            lastProductPage
         })
      }
   }

   setSearch(search) {
      if (this.state.search !== search) {
         this.setState({
            search
         });
      }
   }

   setSearchType(searchType) {
      if (searchType !== this.state.searchType)
      this.setState({
         searchType
      }, () => console.log(this.state.searchType));
   }

   setFilter(filter) {
      this.setState({
         filter
      });
   }

   setSort(sort) {
      this.setState({
         sort
      });
   }

   setHideNavSearch(hide) {
      this.setState({
         hideNavSearch: hide
      });
   }

   setPublisher(publisher) {
      this.setState({
         publisher
      });
   }

   /**
    * This render method contains the whole applications
    */
   render() {
      return(
         <div>
            <NavBar cartStorage={this.state.cartStorage} search={this.state.search} setSearch={this.setSearch} searchType={this.state.searchType} setSearchType={this.setSearchType} hideNavSearch={this.state.hideNavSearch}></NavBar>
            <div className="navbar-overflow"></div>

            <Switch>
               <Route exact path="/" render={routeProps => <Home setFilter={this.setFilter} updateLastProductPage={this.updateLastProductPage}/>}></Route>
               
               <Route path="/about-us" component={AboutUs}></Route>
               
               <Route path="/contact" component={Contact}></Route>
               
               <Route exact path="/products" render={routeProps => <Products {...routeProps} updateCartStorage={this.updateCartStorage} currency={this.state.currency} setCurrency={this.setCurrency}  updateLastProductPage={this.updateLastProductPage} lastProductPage={this.state.lastProductPage} search={this.state.search} setSearch={this.setSearch} searchType={this.state.searchType} setSearchType={this.setSearchType} filter={this.state.filter} setFilter={this.setFilter} sort={this.state.sort} setSort={this.setSort} setHideNavSearch={this.setHideNavSearch} publisher={this.state.publisher} setPublisher={this.setPublisher}/>}></Route>

               <Route exact path="/products/:ipNumber" render={routeProps => <ProductDetails updateCartStorage={this.updateCartStorage} lastProductPage={this.state.lastProductPage} publisher={this.state.publisher} {...routeProps}/>}></Route>

               <Route path="/cart" render={() => <Cart updateCartStorage={this.updateCartStorage} currency={this.state.currency} setCurrency={this.setCurrency}></Cart>}></Route>


               <Route path="/in-development" component={InDevelopment}></Route>
               <Route path="/whats-new" render={routeProps =>  <WhatsNew updateCartStorage={this.updateCartStorage} {...routeProps} />}></Route>
               <Route path="/admin" component={Admin}></Route>
               <Route component={PageNotFoundError}></Route>
            </Switch>

            <Footer />
         </div>
      )
   }
}

export default App;
